<template>
  <el-input
    v-model="childValue"
    :size="size"
    :disabled="disabled"
    :placeholder="placeholder"
    :readonly="readonlyComputed"
    @mouseenter.native="mouseenter"
    @mouseleave.native="mouseleave"
    @change="changeValue"
    @focus="focusAction"
    @blur="blurAction"
  >
    <i slot="suffix" class="el-input__icon el-icon-search" @click="emitFocus" />
    <i v-show="flagHover && childValue" slot="suffix" class="el-input__icon el-icon-circle-close pointer" @click.stop="resetValue" />
  </el-input>
</template>

<script>
export default {
  name: 'InputDialog',
  props: {
    // 绑定值
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'dialog'
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'mini'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      childValue: this.value,
      // 鼠标hover状态
      flagHover: false
    }
  },
  computed: {
    readonlyComputed() {
      if (this.type === 'dialog') return true
      return this.readonly
    }
  },
  watch: {
    value(nv, ov) {
      this.childValue = nv
    }
  },
  methods: {
    emitFocus() {
      this.focus()
    },
    focusAction(e) {
      console.log('组件触发聚焦~')
      this.$emit('focus', e)
    },
    blurAction(e) {
      this.$emit('blur', e)
    },
    mouseenter() {
      this.flagHover = true
    },
    mouseleave() {
      this.flagHover = false
    },
    changeValue() {
      this.$emit('change', this.childValue)
    },
    resetValue() {
      this.childValue = ''
      this.$emit('input', this.childValue)
      this.$emit('clear', this.childValue)
    },
    focus() {
      this.$children[0].focus()
    },
    blur() {
      this.$children[0].blur()
    },
    select() {
      this.$children[0].select()
    }
  }
}
</script>
